
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitoimagicacab() {



    const cardData =
    {
        keyword: ' Mumbai to Imagica Cab   ',
        heading: 'Deva Cabs: Mumbai to Imagica Cab  ',
        headingDescription: 'Deva Cabs offers reliable and enjoyable cab services from Mumbai to Imagica Theme Park, ideal for families, friends, and group outings. Located approximately 50 km from Mumbai, Imagica is a popular amusement destination, and our well-maintained cabs ensure a smooth and comfortable ride through convenient routes. Choose from Sedans, SUVs, or Innova Crysta based on your group size and comfort needs. With experienced drivers, fixed fares, flexible pickup times, and 24/7 availability, Deva Cabs makes your Mumbai to Imagica journey easy, safe, and fun-filled.',

        top: 'Top Places to Visit in Imagica with Deva Cabs',

"topPlaces": [
  {
    "title": "Imagica Theme Park",
    "location": "Khopoli, Maharashtra",
    "description": "Imagica Theme Park is a major amusement destination featuring roller coasters, water rides, 4D shows, live entertainment, and dedicated zones for kids. With over 25 thrilling attractions and beautifully landscaped areas, it offers full-day fun for families and adventure seekers."
  },
  {
    "title": "Imagica Water Park (Imagica Water Kingdom)",
    "location": "Khopoli, Maharashtra",
    "description": "Adjacent to the theme park, Imagica Water Kingdom is India’s largest water park, offering wave pools, high-energy water slides, lazy rivers, surf simulators, and kids’ pools. It's a standout attraction during hot summer days."
  },
  {
    "title": "Snow Park",
    "location": "Imagica Resort, Khopoli, Maharashtra",
    "description": "Imagica Snow Park provides a chilly escape with indoor snow activities like toboggan rides, snow ball fights, snow slides, and ice sculptures. It’s a fun-filled experience, especially refreshing for those looking to beat the tropical heat."
  },
  {
    "title": "Imagica Resort",
    "location": "Khopoli, Maharashtra",
    "description": "Imagica Resort offers themed stays with luxurious rooms and villas overlooking the park. The resort includes pools, a spa, multiple dining options, and exclusive privileges for park guests, making it a perfect getaway destination."
  },
  {
    "title": "Adventure Park (Sandbox)",
    "location": "Imagica Resort Complex, Khopoli, Maharashtra",
    "description": "Sandbox is an adventure sports zone within the Imagica complex, offering activities like zip-lining, paintball, ATV rides, archery, and rock climbing. It’s ideal for thrill-seekers looking for offbeat adventure alongside the main parks."
  },
  {
    "title": "Kidzville",
    "location": "Inside Imagica Theme Park, Khopoli, Maharashtra",
    "description": "Kidzville is a dedicated area within Imagica Theme Park for younger children, featuring gentle rides, interactive play zones, and character meet-and-greets, ensuring a fun and safe experience for the little ones."
  },
  {
    "title": "International Dining Street",
    "location": "Imagica Theme Park, Khopoli, Maharashtra",
    "description": "This vibrant food zone offers a variety of global cuisines, street food favorites, and themed cafes scattered across the park. It’s a great spot to refuel with everything from Indian delicacies to international fare."
  },
  {
    "title": "Water Park Cabanas & Loungers",
    "location": "Imagica Water Kingdom, Khopoli, Maharashtra",
    "description": "Premium cabanas, loungers, and private pool areas are available at Water Kingdom for those seeking a more relaxed and luxurious poolside experience with additional comfort and services."
  },
  {
    "title": "Special Events & Festivals",
    "location": "Across Imagica Complex, Khopoli, Maharashtra",
    "description": "Imagica hosts seasonal events, themed festivals, concerts, and character parades throughout the year. Highlights include Halloween Horror Nights, Holi celebrations, Christmas gala, and drive-in films, adding extra vibrancy to the visit."
  },
  {
    "title": "2-way Entry Combo Tickets",
    "location": "Imagica Theme & Water Park, Khopoli, Maharashtra",
    "description": "The combo tickets allow guests to enjoy both Imagica Theme Park and Water Kingdom on the same day, offering convenience and savings. Ideal for visitors looking to experience the full range of attractions in one trip."
  }
],



"services": [
  {
    "name": "Mumbai to Imagica Cab",
    "description": "Enjoy a comfortable and hassle-free ride from Mumbai to Imagica Theme Park with our reliable cab service. Whether you're visiting for a family day out or a fun trip with friends, our cabs ensure timely pickups and smooth travel to one of Maharashtra’s premier entertainment destinations."
  },
  {
    "name": "Taxi from Mumbai to Imagica Theme Park",
    "description": "Book a convenient taxi from Mumbai to Imagica Theme Park for a stress-free journey. Our professional drivers navigate the best routes so you can relax and focus on enjoying your visit to this exciting theme park."
  },
  {
    "name": "One-way cab hire Mumbai to Imagica",
    "description": "Opt for our one-way cab service from Mumbai to Imagica if you’re planning a single trip. Affordable and comfortable, this option is perfect for visitors looking to reach the park without worrying about return transport."
  },
  {
    "name": "Round trip Imagica cab Mumbai",
    "description": "Make your trip seamless with our round trip cab service between Mumbai and Imagica Theme Park. Enjoy the convenience of a dedicated vehicle for both onward and return journeys, allowing you more time to relax and have fun."
  },
  {
    "name": "Family trip cab to Imagica from Mumbai",
    "description": "Plan a memorable family outing to Imagica with our spacious and comfortable cabs. We provide family-friendly vehicles with ample space for luggage and passengers, ensuring everyone enjoys the journey safely."
  },
  {
    "name": "Chauffeur-driven cab Mumbai to Imagica",
    "description": "Travel with ease in our chauffeur-driven cabs from Mumbai to Imagica. Our professional drivers offer punctual pickups, safe driving, and local insights to enhance your overall travel experience."
  },
  {
    "name": "SUV hire Mumbai to Imagica",
    "description": "For group travel or extra luggage, choose our SUV hire from Mumbai to Imagica. Experience spacious interiors, comfortable seating, and a smooth ride on the way to your fun-filled destination."
  },
  {
    "name": "AC taxi Mumbai to Imagica",
    "description": "Beat the heat with our air-conditioned taxis from Mumbai to Imagica. Enjoy a cool and comfortable journey, perfect for hot summer days or anytime you prefer a premium travel experience."
  },
  {
    "name": "Affordable Mumbai Imagica cab booking",
    "description": "Get the best value for your trip with our affordable cab services from Mumbai to Imagica. We combine competitive pricing with reliable service, making your travel both economical and comfortable."
  },
  {
    "name": "Online Imagica cab service",
    "description": "Book your Mumbai to Imagica cab online quickly and easily. Choose your preferred vehicle and schedule, with instant confirmation and 24/7 customer support to assist you."
  }
],
"tableData": [
  ["Mumbai to Imagica Cab", "-Taxi from Mumbai to Imagica Theme Park"],
  ["One-way cab hire Mumbai to Imagica", "-Round trip Imagica cab Mumbai"],
  ["Family trip cab to Imagica from Mumbai", "-Chauffeur-driven cab Mumbai to Imagica"],
  ["SUV hire Mumbai to Imagica", "-AC taxi Mumbai to Imagica"],
  ["Affordable Mumbai Imagica cab booking", "-Online Imagica cab service"]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Imagica Cab Service",
    "WhyChoosedescription": "Enjoy a hassle-free and comfortable ride from Mumbai to Imagica Theme Park with our reliable cab service. Perfect for family outings, group trips, or solo visits, we ensure timely pickups and drop-offs so you can focus on having fun and making memories without worrying about transportation."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Fun-Filled Travel",
    "WhyChoosedescription": "Our well-maintained, air-conditioned vehicles offer ample space and comfortable seating, ideal for families and groups visiting Imagica. With enough room for luggage and picnic essentials, our cabs make your trip enjoyable and relaxing, ensuring everyone arrives fresh and ready for a day of excitement."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Mumbai-Imagica Route",
    "WhyChoosedescription": "Our professional drivers know the quickest and safest routes from Mumbai to Imagica, avoiding traffic jams and roadblocks. They prioritize your safety and comfort throughout the journey, making your travel smooth, stress-free, and punctual."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We offer clear, upfront pricing that includes fuel, tolls, and driver allowances, with no hidden charges. Our competitive rates help you plan your day trip to Imagica without any budget surprises."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Whether you want to start early in the morning or return late at night after a fun-filled day, our cab service is available round the clock. This flexibility allows you to plan your Imagica visit at your convenience."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Imagica cab is quick and easy through our website or customer support. Receive instant confirmation, driver details, and fare breakdown to plan your trip confidently and conveniently."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "Your safety is paramount. All our vehicles are regularly maintained, sanitized, and equipped with seat belts and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable journey."
  },
  {
    "WhyChooseheading": "Customizable Packages to Suit Your Itinerary",
    "WhyChoosedescription": "We offer flexible travel options including one-way trips, round trips, and extended stays if you wish to explore nearby attractions. Our packages can be tailored to fit your schedule and group size, making your Mumbai to Imagica trip truly personalized."
  }
]













    }








const faqData = [
  {
    question: "Can I book a cab from Mumbai to Imagica with Deva Cabs?",
    answer: "Yes, Deva Cabs offers comfortable and reliable cab services from Mumbai to Imagica Theme Park for family outings and group trips."
  },
  {
    question: "How long is the journey from Mumbai to Imagica by cab?",
    answer: "The trip typically takes around 1.5 to 2 hours depending on traffic conditions."
  },
  {
    question: "What types of vehicles are available for Mumbai to Imagica trips?",
    answer: "We provide a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for group sizes of all types."
  },
  {
    question: "Can I book a round-trip cab from Mumbai to Imagica?",
    answer: "Yes, both one-way and round-trip cab bookings are available according to your convenience."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Additional charges like tolls and parking fees are generally extra and will be communicated upfront during booking."
  },
  {
    question: "Is the Mumbai to Imagica cab service available throughout the day?",
    answer: "Yes, Deva Cabs operates 24/7, allowing you to schedule your ride at any preferred time."
  },
  {
    question: "Is it safe to travel to Imagica by cab with Deva Cabs?",
    answer: "Absolutely. Our drivers are professional, experienced, and background-verified to ensure a safe journey."
  },
  {
    question: "Can I request multiple stops or sightseeing on the way to Imagica?",
    answer: "Yes, customized trip plans with multiple stops can be arranged upon request."
  },
  {
    question: "Is this service suitable for families and large groups?",
    answer: "Yes, our fleet includes vehicles perfect for families and groups of any size."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Imagica cab service?",
    answer: "Deva Cabs offers punctual service, clean vehicles, experienced drivers, and transparent pricing to make your trip hassle-free."
  }
];

const testimonialData = [
  {
    id: 55,
    name: 'Mr. Kunal Joshi',
    role: 'Family Traveler',
    review: 'We booked a cab from Mumbai to Imagica with Deva Cabs. The ride was smooth, the driver was friendly, and everything went perfectly.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 56,
    name: 'Ms. Sneha Patel',
    role: 'Group Traveler',
    review: 'Deva Cabs provided a spacious vehicle for our group trip to Imagica. The service was reliable and comfortable throughout.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Imagica Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-imagica-cab.jpg", // Replace with actual image URL
  "description": "Book Mumbai to Imagica cab with Deva Cabs. Comfortable and affordable one-way and round-trip taxis to Imagica Theme Park. Choose from AC, SUV, chauffeur-driven, and family-friendly cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "987"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-imagica-cab" // Replace with actual page URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Imagica Cab | Book Taxi to Imagica Theme Park | Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Imagica cab online with Deva Cabs. Get one-way or round trip taxi service to Imagica Theme Park. AC, SUV, chauffeur-driven, and affordable family cabs available." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Imagica Cab, Taxi from Mumbai to Imagica Theme Park, One-way cab hire Mumbai to Imagica, Round trip Imagica cab Mumbai, Family trip cab to Imagica from Mumbai, Chauffeur-driven cab Mumbai to Imagica, SUV hire Mumbai to Imagica, AC taxi Mumbai to Imagica, Affordable Mumbai Imagica cab booking, Online Imagica cab service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitoimagicacab;